// Risks store — admin-editable, persisted per company to localStorage.
// Shared by RisksCard on the investor page.

const STORAGE_PREFIX = 'finkloz_risks_';
const CHANGE_EVENT = 'finkloz:risks-changed';

function key(companyId) {
  return STORAGE_PREFIX + (companyId || 'default');
}

function loadBaseline() {
  try {
    // eslint-disable-next-line global-require
    const { RISKS } = require('./investorData');
    if (Array.isArray(RISKS) && RISKS.length) return RISKS.map(r => ({ ...r }));
  } catch { /* ignore */ }
  return [];
}

export function getRisks(companyId) {
  try {
    const raw = localStorage.getItem(key(companyId));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch { /* ignore */ }
  return loadBaseline();
}

export function saveRisks(companyId, risks) {
  try {
    localStorage.setItem(key(companyId), JSON.stringify(risks));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveRisks failed', e);
  }
}

export function subscribeToRisksChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function newRiskId() {
  return 'risk-' + Math.random().toString(36).slice(2, 9);
}
